import { Channels } from 'generated-graphql/types';

export const SHARED_SOURCING_AVAILABLE_CHANNELS = [
  Channels.Email,
  Channels.Sms
] as const;
